import type { CapsuleState } from 'new/stores/capsules/capsule.slice';

export const selectCapsulesSlice = (rootState: { capsules?: CapsuleState }) => {
  return (
    rootState.capsules ?? {
      byId: [],
      entities: {},
    }
  );
};
